import draftModelGuide from "./draft-model";
import firstEltSyncGuide from "./FirstEltSynced";
import exampleModelGuide from "./example-model";

const Guides = new Map([
  [exampleModelGuide.id, exampleModelGuide],
  [draftModelGuide.id, draftModelGuide],
  [firstEltSyncGuide.id, firstEltSyncGuide],
]);

export default Guides;
